/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { useRef, useState } from 'react'
import {
  Box,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  Button,
  ModalBody,
  Spinner,
  Flex,
  Spacer
} from '@chakra-ui/react'
import { useLoadScript } from '@react-google-maps/api'
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url'
import Map from './Map'

interface ModalMapFormState {
  isOpen: boolean
  onClose: () => void
  setValue: any
}

const useScroll = () => {
  const formDiv = useRef(null)
  // @ts-expect-error
  const executeScroll = () => formDiv.current.scrollIntoView({ behavior: 'smooth' })

  return [executeScroll, formDiv]
}

const libraries: Libraries = ['places']

export default function ModalGoogleMap({ isOpen, onClose, setValue }: ModalMapFormState) {
  const [clickedLatLng, setClickedLatLng] = useState<{ lat: number; lng: number; placeId: string; name: string }>()
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY || '',
    language: 'th',
    region: 'ap',
    libraries
  })
  const [executeScroll, formDiv] = useScroll()

  const onDone = () => {
    setValue('incidentLocation', clickedLatLng?.name)
    setValue('incidentLocationLat', clickedLatLng?.lat)
    setValue('incidentLocationLng', clickedLatLng?.lng)
    onClose()
  }

  if (loadError != null)
    return (
      <Box w="100%" h="100%" minH="80vh" display="flex" alignItems="center" justifyContent="center" fontSize="18px">
        Error loading maps
      </Box>
    )

  return (
    <Modal
      size="full"
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      blockScrollOnMount={false}
      preserveScrollBarGap={true}
    >
      <ModalOverlay />
      <ModalContent h="100vh">
        <Flex gap="4" minWidth="max-content" alignItems="center" fontSize="16px" mx="2%" ref={formDiv}>
          <ModalCloseButton float="left" position="initial" />
          <Spacer />
          <ModalHeader w="100%" minW="180px" textAlign="center" fontSize="16px" gap="2">
            Select location
          </ModalHeader>
          <Spacer />
          <Button colorScheme="dark" variant="ghost" onClick={() => onDone()}>
            Done
          </Button>
        </Flex>

        <ModalBody p="0px" overflow="hidden">
          {isLoaded ? (
            <Map setClickedLatLng={setClickedLatLng} executeScroll={executeScroll} />
          ) : (
            <Box
              w="100%"
              h="100%"
              minH="80vh"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="18px"
            >
              <Spinner size="lg" mr="10px" />
              Loading...
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
